import { useContext } from "react";
import { ViewIntakeDrawerContext } from "./ViewIntakeProvider";

export const useViewIntakeDrawer = () => useContext(ViewIntakeDrawerContext);
